import { createSlice } from "@reduxjs/toolkit";

export const cspmSlice = createSlice({
  name: "cspm",
  initialState: {
    isGettingCspmChecks: false,
    getCspmChecksMessage: null,
    getCspmChecksError: null,
    cspmChecks: null,
    isGettingCspmResources: false,
    getCspmResourcesMessage: null,
    getCspmResourcesError: null,
    cspmResources: null,
    isCreatingCspmWorkload: false,
    createCspmWorkloadMessage: null,
    createCspmWorkloadError: null,
    createdCspmWorkload: null,
    isEditingCspmWorkload: false,
    editCspmWorkloadMessage: null,
    editCspmWorkloadError: null,
    editedCspmWorkload: null,
    isDeletingCspmWorkload: false,
    deleteCspmWorkloadMessage: null,
    deleteCspmWorkloadError: null,
    deletedCspmWorkload: null,
    isInitiatingCspmScan: false,
    initiateCspmScanMessage: null,
    initiateCspmScanError: null,
    initiatedCspmScan: null,
    isDownloadingCspmReport: false,
    downloadCspmReportMessage: null,
    downloadCspmReportError: null,
    downloadedCspmReport: null,
  },
  reducers: {
    getCspmChecks: (state) => {
      state.isGettingCspmChecks = true;
      state.getCspmChecksMessage = null;
      state.getCspmChecksError = null;
    },
    getCspmChecksSuccessful: (state, action) => {
      state.isGettingCspmChecks = false;
      state.getCspmChecksMessage = action.payload?.message || action.payload?.data?.message || action.payload?.data || 'Success';
      state.getCspmChecksError = null;
      const { status, ...checksData } = action.payload;
      state.cspmChecks = checksData;
    },
    getCspmChecksFailure: (state, action) => {
      state.isGettingCspmChecks = false;
      state.getCspmChecksMessage = null;
      state.getCspmChecksError = action.payload.message;
    },
    getCspmResources: (state) => {
      state.isGettingCspmResources = true;
      state.getCspmResourcesMessage = null;
      state.getCspmResourcesError = null;
    },
    getCspmResourcesSuccessful: (state, action) => {
      state.isGettingCspmResources = false;
      state.getCspmResourcesMessage = action.payload?.message || action.payload?.data?.message || action.payload?.data || 'Success';
      state.getCspmResourcesError = null;
      const { status, ...resourcesData } = action.payload;
      state.cspmResources = resourcesData;
    },
    getCspmResourcesFailure: (state, action) => {
      state.isGettingCspmResources = false;
      state.getCspmResourcesMessage = null;
      state.getCspmResourcesError = action.payload.message;
    },
    createCspmWorkload: (state) => {
      state.isCreatingCspmWorkload = true;
      state.createCspmWorkloadMessage = null;
      state.createCspmWorkloadError = null;
    },
    createCspmWorkloadSuccessful: (state, action) => {
      state.isCreatingCspmWorkload = false;
      state.createCspmWorkloadMessage = action.payload?.message || action.payload?.data?.message || action.payload?.data || 'Success';
      state.createCspmWorkloadError = null;
      state.createdCspmWorkload = action.payload;
    },
    createCspmWorkloadFailure: (state, action) => {
      state.isCreatingCspmWorkload = false;
      state.createCspmWorkloadMessage = null;
      state.createCspmWorkloadError = action.payload.message;
    },
    editCspmWorkload: (state) => {
      state.isEditingCspmWorkload = true;
      state.editCspmWorkloadMessage = null;
      state.editCspmWorkloadError = null;
    },
    editCspmWorkloadSuccessful: (state, action) => {
      state.isEditingCspmWorkload = false;
      state.editCspmWorkloadMessage = action.payload?.message || action.payload?.data?.message || action.payload?.data || 'Success';
      state.editCspmWorkloadError = null;
      state.editedCspmWorkload = action.payload;
    },
    editCspmWorkloadFailure: (state, action) => {
      state.isEditingCspmWorkload = false;
      state.editCspmWorkloadMessage = null;
      state.editCspmWorkloadError = action.payload.message;
    },
    deleteCspmWorkload: (state) => {
      state.isDeletingCspmWorkload = true;
      state.deleteCspmWorkloadMessage = null;
      state.deleteCspmWorkloadError = null;
    },
    deleteCspmWorkloadSuccessful: (state, action) => {
      state.isDeletingCspmWorkload = false;
      state.deleteCspmWorkloadMessage = action.payload?.message || action.payload?.data?.message || action.payload?.data || 'Success';
      state.deleteCspmWorkloadError = null;
      state.deletedCspmWorkload = action.payload;
    },
    deleteCspmWorkloadFailure: (state, action) => {
      state.isDeletingCspmWorkload = false;
      state.deleteCspmWorkloadMessage = null;
      state.deleteCspmWorkloadError = action.payload.message;
    },
    initiateCspmScan: (state) => {
      state.isInitiatingCspmScan = true;
      state.initiateCspmScanMessage = null;
      state.initiateCspmScanError = null;
    },
    initiateCspmScanSuccessful: (state, action) => {
      state.isInitiatingCspmScan = false;
      state.initiateCspmScanMessage = action.payload?.message || action.payload?.data?.message || action.payload?.data || 'Success';
      state.initiateCspmScanError = null;
      state.initiatedCspmScan = action.payload;
    },
    initiateCspmScanFailure: (state, action) => {
      state.isInitiatingCspmScan = false;
      state.initiateCspmScanMessage = null;
      state.initiateCspmScanError = action.payload.message;
    },
    downloadCspmReport: (state) => {
      state.isDownloadingCspmReport = true;
      state.downloadCspmReportMessage = null;
      state.downloadCspmReportError = null;
    },
    downloadCspmReportSuccessful: (state, action) => {
      state.isDownloadingCspmReport = false;
      state.downloadCspmReportMessage = action.payload || 'Success';
      state.downloadCspmReportError = null;
      state.downloadedCspmReport = action.payload;
    },
    downloadCspmReportFailure: (state, action) => {
      state.isDownloadingCspmReport = false;
      state.downloadCspmReportMessage = null;
      state.downloadCspmReportError = action.payload.message;
    },
    clearAllCspmMessages: (state) => {
      state.getCspmChecksMessage = null;
      state.getCspmChecksError = null;
      state.getCspmResourcesMessage = null;
      state.getCspmResourcesError = null;
      state.createCspmWorkloadMessage = null;
      state.createCspmWorkloadError = null;
      state.editCspmWorkloadMessage = null;
      state.editCspmWorkloadError = null;
      state.deleteCspmWorkloadMessage = null;
      state.deleteCspmWorkloadError = null;
      state.initiateCspmScanMessage = null;
      state.initiateCspmScanError = null;
      state.downloadCspmReportMessage = null;
      state.downloadCspmReportError = null;
      state.downloadedCspmReport = null;
      state.isDownloadingCspmReport = false;
    },
  }
});

export const {
  getCspmChecks,
  getCspmChecksSuccessful,
  getCspmChecksFailure,
  getCspmResources,
  getCspmResourcesSuccessful,
  getCspmResourcesFailure,
  createCspmWorkload,
  createCspmWorkloadSuccessful,
  createCspmWorkloadFailure,
  editCspmWorkload,
  editCspmWorkloadSuccessful,
  editCspmWorkloadFailure,
  deleteCspmWorkload,
  deleteCspmWorkloadSuccessful,
  deleteCspmWorkloadFailure,
  initiateCspmScan,
  initiateCspmScanSuccessful,
  initiateCspmScanFailure,
  downloadCspmReport,
  downloadCspmReportSuccessful,
  downloadCspmReportFailure,
  clearAllCspmMessages,
} = cspmSlice.actions;

export default cspmSlice.reducer; 